module.exports = __webpack_public_path__ + "static/media/bg_tile.a3522db8.jpg";